import { Avatar, Box, Flex, Stack, Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import CourseQ from '@/queries/CourseQ'
import SeriesQ from '@/queries/SeriesQ'
import SessionQ from '@/queries/SessionQ'
import TopicQ from '@/queries/TopicQ'
import type { Query } from '@/client/query'

import HostAvatarsFromQuery from '@/components/Host/HostAvatarsFromQuery'

const SessionSummary: React.FC<{ session: Query; hideHostAvatars?: boolean }> = ({
  session,
  hideHostAvatars = false,
}) => {
  const series = session.one(SessionQ.getSeries())
  const topic = session.one(SessionQ.getTopic())
  const course = topic.one(TopicQ.getCourse())
  const topicName = topic(TopicQ.name) ?? ''
  const sessionTitle = session(SessionQ.getDisplayTitle())
  const seriesTitle = series(SeriesQ.title)
  const courseName = course(CourseQ.name) ?? ''
  const sessionStartDate = DateTime.fromISO(`${session(SessionQ.start_date)}`)

  return (
    <Box
      bg="bg.subtle"
      borderRadius="8px"
      p="16px"
      border="2px solid"
      borderColor="border.emphasized"
    >
      <Stack
        direction={['column', 'row']}
        align={['flex-start', 'center']}
        justify="space-between"
        spacing={4}
      >
        <Stack direction="row" align="center">
          <Stack direction="row" align="center" spacing={3}>
            <Avatar
              width={12}
              height={12}
              borderRadius={8}
              src={topic(TopicQ.icon) ?? ''}
              name={topicName}
            />
            <Box>
              <Text fontWeight="bold">
                {seriesTitle ?? courseName}
                {sessionTitle != null ? `: ${sessionTitle}` : null}
              </Text>
              <Box color="fg.muted" fontWeight="bold">
                {sessionStartDate.toLocaleString({
                  month: 'short',
                  day: 'numeric',
                  weekday: 'long',
                })}
              </Box>
            </Box>
          </Stack>
        </Stack>

        <Flex
          direction="column"
          align={['flex-start', 'flex-end']}
          flex={1}
          display={hideHostAvatars ? 'none' : 'flex'}
        >
          <Stack direction="row" align="center" spacing={2} mb={2}>
            <HostAvatarsFromQuery sessionOrSeries={session} isSession isTooltip />
          </Stack>
        </Flex>
      </Stack>
    </Box>
  )
}

export default SessionSummary
